import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const warehouseReceivingTypesAdapter = getAdapter({ idFieldName: 'value' });

const warehouseReceivingTypesSlice = createSlice({
  name: 'warehouseReceivingTypes',
  initialState: warehouseReceivingTypesAdapter.getInitialState(),
  reducers: {
    setWarehouseReceivingTypes: (state, { payload: { receivingTypes } }) => {
      warehouseReceivingTypesAdapter.setAll(state, receivingTypes);
    },
  },
});

const selectors = warehouseReceivingTypesAdapter.getSelectors(({ warehouseReceivingTypes }) => warehouseReceivingTypes);

export const getWarehouseReceivingTypesIncludingDeleted = (state) => selectors.selectAll(state);

export const getWarehouseReceivingTypes = (state) => getWarehouseReceivingTypesIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const {
  setWarehouseReceivingTypes,
} = warehouseReceivingTypesSlice.actions;

export default warehouseReceivingTypesSlice.reducer;
